<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <holidays>
            </holidays> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import holidays from './todo-holidays'
    export default {
        components: {
            holidays
        }
    }
    </script>
    <style lang='scss'>
        .bg-breadcrum{
            background:#fff!important;
        }
        .link-default{
            color: #666!important;
        }
    
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-calendar/base-holidays.vue